export default __webpack_public_path__ + "static/media/enghien23.c12057b2.jpg";